import { useUserData } from '../../../hooks'
import { isStaffUser } from '../../../utils/user'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'
import { NewsboardPostFooter } from '../NewsboardPost'

import { getNewsboardPostProfileFooterData } from './NewsboardPostProfileHeaderFooter.utils'

import * as styles from './NewsboardPostProfileHeaderFooter.module.css'

function NewsboardPostProfileHeaderFooter({ isLoading }) {
  const { postData } = useNewsboardPostProfileContext()

  const userData = useUserData()
  const isStaff = Boolean(userData) && isStaffUser(userData)

  const footerData = getNewsboardPostProfileFooterData({ isStaff, postData })

  return (
    <div className={styles.NewsboardPostProfileHeaderFooter}>
      <NewsboardPostFooter data={footerData} loading={isLoading || !postData} />
    </div>
  )
}

export default NewsboardPostProfileHeaderFooter
